// Add this to assets/sellup-quantity-sync.js
(function() {
  'use strict';
  
  console.log('SellUp Quantity Sync: Script loaded');
  
  // Wait for both jQuery and the page to be ready
  function init() {
    if (typeof jQuery === 'undefined') {
      console.log('SellUp Quantity Sync: Waiting for jQuery...');
      setTimeout(init, 100);
      return;
    }
    
    var $ = jQuery;
    console.log('SellUp Quantity Sync: jQuery found');
    
    // Wait for SellUp wrapper to exist
    function waitForSellUp() {
      if ($('#launchtip_upsell_select_wrapper, #launchtip_upsell_select_wrapper1').length === 0) {
        console.log('SellUp Quantity Sync: Waiting for SellUp to load...');
        setTimeout(waitForSellUp, 500);
        return;
      }
      
      console.log('SellUp Quantity Sync: SellUp loaded, initializing...');
      setupQuantitySync();
    }
    
    function setupQuantitySync() {
      var $mainQuantityInput = $('input[name="quantity"]').not('#launchtip_upsell_select_wrapper input, #launchtip_upsell_select_wrapper1 input').first();
      
      console.log('Main quantity input found:', $mainQuantityInput.length > 0);
      console.log('Main quantity input ID:', $mainQuantityInput.attr('id'));
      
      // Get main product quantity
      function getMainQuantity() {
        var qty = parseInt($mainQuantityInput.val()) || 1;
        console.log('Current main quantity:', qty);
        return qty;
      }
      
      // Update all checkbox product quantities
      function updateCheckboxQuantities() {
        var mainQty = getMainQuantity();
        console.log('Updating checkbox quantities to:', mainQty);
        
        $('#launchtip_upsell_select_wrapper input[name="quantity"], #launchtip_upsell_select_wrapper1 input[name="quantity"]').each(function() {
          $(this).val(mainQty);
          console.log('Updated checkbox quantity input to:', mainQty);
        });
      }
      
      // Listen for main product quantity changes
      $mainQuantityInput.on('change input', function() {
        console.log('Main quantity changed');
        updateCheckboxQuantities();
      });
      
      // Listen for +/- button clicks
      $(document).on('click', '.js-qty__adjust', function() {
        console.log('Quantity adjust button clicked');
        setTimeout(function() {
          updateCheckboxQuantities();
        }, 150);
      });
      
      // When checkbox is toggled
      $(document).on('change', '#launchtip_upsell_select_wrapper input[type=checkbox], #launchtip_upsell_select_wrapper1 input[type=checkbox]', function() {
        console.log('Checkbox toggled:', $(this).is(':checked'));
        if ($(this).is(':checked')) {
          var $form = $(this).closest('.onpage_item');
          var mainQty = getMainQuantity();
          $form.find('input[name="quantity"]').val(mainQty);
          console.log('Set checkbox quantity to:', mainQty);
        }
      });
      
      // CRITICAL: Intercept before SellUp processes the add to cart
      // Store the original event handler
      var originalAddToCart = window.action_offerAddToCartHandler;
      
      // Intercept the main add to cart button
      $(document).on('click', 'button[name="add"], .add-to-cart', function(e) {
        console.log('Add to cart clicked, updating quantities...');
        updateCheckboxQuantities();
      });
      
      // Monitor for SellUp's fetch calls
      if (window.fetch) {
        var originalFetch = window.fetch;
        window.fetch = function() {
          console.log('Fetch intercepted, updating quantities...');
          updateCheckboxQuantities();
          return originalFetch.apply(this, arguments);
        };
      }
      
      // Set initial quantities
      updateCheckboxQuantities();
      
      console.log('✓ SellUp Quantity Sync: Fully initialized');
    }
    
    // Start waiting for SellUp
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForSellUp);
    } else {
      waitForSellUp();
    }
  }
  
  // Start initialization
  init();
  
})();